import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const RefundPolicy = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Refund Policy</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="refund-policy">
                          <h6>1. Introduction</h6>
                          <p>
                            This Refund Policy outlines the terms and conditions
                            under which refunds are issued for transactions made
                            through the {APP_INFO.companyName}. The policy
                            ensures that all refund requests are handled fairly,
                            transparently, and efficiently.
                          </p>

                          <h6>2. Eligibility for Refund</h6>
                          <ol>
                            <li>
                              Refunds are applicable only for failed or
                              unsuccessful recharge transactions where the
                              amount has been debited from the user’s account
                              but the recharge has not been processed.
                            </li>
                            <li>
                              We will refund the amount in case the user has
                              paid for some services, got confirmation about the
                              payment but does not receive those services to
                              utilize. In such cases, we request the user to
                              drop us a complaint on our official Email ID and
                              let us evaluate the scenario. Once we investigate
                              and make a conclusion, we will refund your amount
                              to your bank account.
                            </li>
                            <li>
                              Refunds will not be provided for successful
                              transactions, services already rendered, or if the
                              user changes their mind after a recharge
                              transaction has been completed.
                            </li>
                          </ol>

                          <h6>3. Refund Request Process</h6>
                          <ol>
                            <li>
                              Users must submit a refund request within 7 days
                              from the date of the transaction.
                            </li>
                            <li>
                              Refund requests can be submitted through the app’s
                              support section or by contacting customer service
                              via email/phone.
                            </li>
                            <li>
                              Users must provide transaction details, including
                              the transaction ID, date, and amount, along with a
                              brief description of the issue.
                            </li>
                          </ol>

                          <h6>4. Verification and Processing</h6>
                          <ol>
                            <li>
                              Once a refund request is received, the company
                              will verify the transaction details and the
                              validity of the refund claim.
                            </li>
                            <li>
                              The verification process may take up to 3-5
                              working days.
                            </li>
                            <li>
                              Upon successful verification, the refund will be
                              processed, and the amount will be credited back to
                              the user’s account or original payment method.
                            </li>
                          </ol>

                          <h6>5. Refund Timeframe</h6>
                          <ol>
                            <li>
                              Refunds are typically processed within 3-5 working
                              days after verification.
                            </li>
                            <li>
                              The actual time it takes for the refunded amount
                              to reflect in the user’s account may vary
                              depending on the payment method and banking
                              partner.
                            </li>
                          </ol>

                          <h6>6. Non-Refundable Situations</h6>
                          <ol>
                            <li>
                              No refund will be provided if the transaction was
                              successful, and the recharge service was delivered
                              as intended.
                            </li>
                            <li>
                              Refunds will not be issued if the user provides
                              incorrect information, leading to a failed
                              transaction.
                            </li>
                            <li>
                              We will not be liable for any refund if the user
                              fails to perform KYC at the initial stage. Each
                              user has to go through a successful KYC
                              verification once. Thus, it is mandatory to keep
                              the correct KYC documents ready before initiating
                              any payment to us.
                            </li>
                          </ol>

                          <h6>7. Dispute Resolution</h6>
                          <p>
                            In case of any disputes related to refunds, users
                            can escalate the matter to our customer support
                            team. The company will investigate and resolve
                            disputes within 15 working days.
                          </p>

                          <h6>8. Policy Updates</h6>
                          <p>
                            {APP_INFO.companyName} reserves the right to update
                            this Refund Policy at any time. Users will be
                            informed of significant changes via app
                            notifications or email.
                          </p>

                          <h6>9. Contact Information</h6>
                          <p>
                            For refund-related inquiries, users can contact our
                            support team at{" "}
                            <a href={`mailto:${APP_INFO.email}`}>
                              {APP_INFO.email}
                            </a>
                            .
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
